const STORAGE_KEY = 'heiNewsletterPopupDismissedAt'
const PAGE_VIEW_KEY = 'heiNewsletterPopupPageViews'
const DISMISS_DURATION = 30 * 24 * 60 * 60 * 1000
const SCROLL_THRESHOLD = 0.8

// Keep these flags false/true for normal behavior. They make local QA easier
// without changing the trigger and dismissal logic below.
const OPEN_IMMEDIATELY = false
const SAVE_DISMISSAL = true

const canUseStorage = (storage) => {
    try {
        const key = '__heiNewsletterPopupStorageTest'
        storage.setItem(key, key)
        storage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

const getStorage = (storage) => {
    if (!storage || !canUseStorage(storage)) {
        return null
    }

    return storage
}

const localStore = getStorage(window.localStorage)
const sessionStore = getStorage(window.sessionStorage)

const isDismissed = (version) => {
    if (!localStore) {
        return false
    }

    const dismissal = JSON.parse(localStore.getItem(STORAGE_KEY) || '{}')
    const dismissedAt = Number(dismissal.dismissedAt)

    if (!dismissedAt) {
        return false
    }

    // Tie dismissal to the Newsletter single's updated timestamp so content
    // edits can show the popup again without waiting for the 30-day window.
    return dismissal.version === version && Date.now() - dismissedAt < DISMISS_DURATION
}

const dismiss = (version) => {
    localStore?.setItem(STORAGE_KEY, JSON.stringify({
        dismissedAt: Date.now(),
        version,
    }))
}

const incrementPageViews = (version) => {
    if (!sessionStore) {
        return 1
    }

    const storedPageViews = JSON.parse(sessionStore.getItem(PAGE_VIEW_KEY) || '{}')
    const pageViews = (storedPageViews.version === version ? Number(storedPageViews.pageViews || 0) : 0) + 1

    sessionStore.setItem(PAGE_VIEW_KEY, JSON.stringify({
        pageViews,
        version,
    }))

    return pageViews
}

const getScrollProgress = () => {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight

    if (scrollableHeight <= 0) {
        return 0
    }

    return window.scrollY / scrollableHeight
}

const newsletterPopup = {
    init() {
        const popup = document.querySelector('[data-newsletter-popup]')
        const version = popup?.dataset.newsletterPopupVersion || ''

        if (!popup || (!OPEN_IMMEDIATELY && isDismissed(version))) {
            return
        }

        const dismissTriggers = popup.querySelectorAll('[data-newsletter-popup-dismiss]')
        const closeButton = popup.querySelector('button[data-newsletter-popup-dismiss]')
        const form = popup.querySelector('form')
        let isOpen = false
        let hasOpened = false

        const open = () => {
            if (hasOpened || isOpen || isDismissed(version)) {
                return
            }

            hasOpened = true
            isOpen = true
            popup.hidden = false
            closeButton?.focus()
            window.removeEventListener('scroll', handleScroll)
        }

        const close = () => {
            if (!isOpen) {
                return
            }

            if (SAVE_DISMISSAL) {
                dismiss(version)
            }
            isOpen = false
            popup.hidden = true
            window.removeEventListener('scroll', handleScroll)
        }

        const handleScroll = () => {
            if (getScrollProgress() >= SCROLL_THRESHOLD) {
                open()
            }
        }

        dismissTriggers.forEach(trigger => {
            trigger.addEventListener('click', close)
        })

        form?.addEventListener('submit', close)

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && isOpen) {
                close()
            }
        })

        if (OPEN_IMMEDIATELY) {
            open()
            return
        }

        // First-page visitors see the popup only after they are deep enough
        // into the page to indicate engagement. Returning visitors in the same
        // session can see it on their next scroll, avoiding early page-load
        // interruption while preserving the second-page prompt behavior.
        const shouldOpenOnAnyScroll = incrementPageViews(version) >= 2

        if (shouldOpenOnAnyScroll) {
            window.addEventListener('scroll', open, { once: true, passive: true })
            return
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()
    }
}

export default newsletterPopup
